export const SportViewTypeEnum = {
  Standard: 1,
  African: 2,
  Latin: 3,
  Asian: 4,
  Modern: 5
  // Paper: 5,

}

export const SportView = {
    [SportViewTypeEnum.Standard]: "europeanView",
    [SportViewTypeEnum.African]: "africanView",
    [SportViewTypeEnum.Latin]: "LatinoView",
    // [SportViewTypeEnum.Paper]: "paperView",
    [SportViewTypeEnum.Asian]: "AsianView",
    [SportViewTypeEnum.Modern]: "ModernView",
}